import React, { useMemo, useState, useContext } from 'react'
import { Row, Col, useToaster, Button } from 'react-angle-dashboard-components'
import useStep from '../../hooks/use-step'
import { GbsStore } from '../../store'
import { useStepData } from '../../store/selectors'
import { Question } from '../../components/Question'
import { Paths } from '../../routes/paths'
import { Actions } from '../../store/actions'
import { emailService, groupService } from '../../services'
import { useHistory } from 'react-router-dom'
import { DateHandler } from '@angle/utils'

const stepKey = 'enrollment'

export const Enrollment = () => {
  const { dispatch } = useContext(GbsStore)
  const history = useHistory()
  const stepData = useStepData(stepKey)
  const [value, setValue] = useState<number | null>(stepData?.value || null)
  const [isLoading, setIsLoading] = useState(false)

  const { show } = useToaster()

  const options = useMemo(() => {
    const options = []
    const date = DateHandler.startOf('month')
    const currentDate = DateHandler.get('date')

    // on the 20th of the month, we need to only allow enrollment for the month after
    if (currentDate >= 20) {
      date.add(1, 'month')
    }

    for (let i = 0; i < 12; i++) {
      date.add(1, 'month')
      // hard code stopping at Dec 2021 until we have rates for next year
      if (date.get('month') === 0) {
        break
      }
      options.push({
        label: date.format('MMMM YYYY'),
        value: date.format('YYYY-MM-DD'),
        text: ''
      })
    }

    return options
  }, [])

  const enroll = async () => {
    setIsLoading(true)

    try {
      await groupService.modifyGroup({
        self_serve_status: 'completed',
        coverage_effective_date: value
      })
      await emailService.sendOnboardingEmail()

      dispatch({
        type: Actions.SetStepData,
        payload: {
          stepKey,
          stepData: { value }
        }
      })
    } catch (error: any) {
      setIsLoading(false)
      show({
        message:
          error.message ||
          'There was an error saving your enrollment information, please try again or contact our support team',
        type: 'danger'
      })
    }

    setIsLoading(false)
    history.push(Paths.onboarding)
  }

  const stepConfig = useMemo(() => {
    return {
      bottomBar: {
        hidden: true
      },
      topBar: {
        completedPercentage: 100,
        completed: true
      }
    }
  }, [])

  useStep(stepKey, stepConfig, dispatch)
  return (
    <div style={{ marginTop: '10%' }}>
      <Row>
        <Col xs={12}>
          <Question
            options={options}
            type="select"
            defaultValue={value}
            text="Enrollment"
            highlight={false}
            placeholder="Choose a date"
            subtitle={<p>When would you like your policy to begin?</p>}
            onChange={(value) => setValue(value)}
          ></Question>
          <div className="text-center">
            <Button
              style={{ width: 130, marginTop: 5 }}
              variant="primary"
              onClick={enroll}
              disabled={isLoading}
            >
              Next
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Enrollment
